module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_16_4.224fd2c2.jpeg";